import React, { useState, useEffect } from 'react';
import Footer from '../Footer';
import './styles/AnnouncementsPage.css';

// API Base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const AnnouncementsPage = () => {
  const [announcements, setAnnouncements] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE_URL}/announcements`);
      if (!response.ok) {
        throw new Error('Failed to fetch announcements');
      }
      const data = await response.json();
      setAnnouncements(data);
    } catch (error) {
      console.error('Error loading announcements:', error);
      setError('Hiba történt a bejelentések betöltése során.');
    } finally {
      setIsLoading(false);
    }
  };

  const formatContent = (content) => {
    if (!content) return null;
    
    // Content is already HTML from the rich text editor
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  const getPostTypeLabel = (type) => {
    switch (type) {
      case 'important': return 'Fontos közlemény';
      case 'event': return 'Esemény';
      case 'info': return 'Információ';
      default: return 'Bejelentés';
    }
  };

  return (
    <div className="announcements-page">
      <section className="announcements-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">📢 Bejelentések</h2>
            <p className="section-subtitle">
              Aktuális hírek és közlemények a személyzettől
            </p>
          </div>

          {isLoading ? (
            <div className="loading-state">
              <p>Bejelentések betöltése...</p>
            </div>
          ) : error ? (
            <div className="error-state">
              <p>{error}</p>
              <button onClick={loadAnnouncements} className="retry-btn">
                Újrapróbálás
              </button>
            </div>
          ) : announcements.length === 0 ? (
            <div className="empty-state">
              <p>Jelenleg nincsenek bejelentések.</p>
            </div>
          ) : (
            <div className="posts-container">
              {announcements.map(announcement => (
                <article key={announcement._id} className={`post-card ${announcement.type} ${announcement.pinned ? 'pinned' : ''}`}>
                  {announcement.pinned && (
                    <div className="pinned-badge">
                      Kiemelt
                    </div>
                  )}
                  
                  <div className="post-header">
                    <div className="post-meta">
                      <span className="post-type">
                        {getPostTypeLabel(announcement.type)}
                      </span>
                      <span className="post-date">
                        {new Date(announcement.createdAt).toLocaleDateString('hu-HU', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </span>
                    </div>
                    
                    <h3 className="post-title">{announcement.title}</h3>
                  </div>

                  <div className="post-content">
                    {formatContent(announcement.content)}
                  </div>

                  <div className="post-footer">
                    <div className="author-info">
                      <div className="author-details">
                        <span className="author-name">{announcement.author}</span>
                        <span className="author-role">{announcement.role}</span>
                      </div>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          )}
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AnnouncementsPage;
